import { APP_TYPE_INDIVIDUAL } from 'features/ApplicationEntry/constants';
import locationHelper from 'shared/utils/locationHelper';

class SubmitCreditApplication {
	constructor(
		applicantIndicator,
		applicant,
		coApplicant,
		salespersonId = '',
		customerId = '',
		sessionId = '',
		returnUrl = '',
		providerId = '',
		cfaTraceId = '',
		eStatementAutoEnrollment = '',
	) {
		this.applicantIndicator = applicantIndicator || APP_TYPE_INDIVIDUAL;
		this.applicant = applicant;
		this.coApplicant = coApplicant;
		this.salespersonId = salespersonId || '';
		this.customerId = customerId || '';
		this.sessionId = sessionId || '';
		this.returnUrl = returnUrl || '';
		this.locationId = locationHelper.location;
		this.providerId = providerId || '';
		this.cfaTraceId = cfaTraceId || '';
		this.eStatementAutoEnrollment = eStatementAutoEnrollment || '';
	}
}

export default SubmitCreditApplication;
